module.exports = __webpack_public_path__ + "img/蕲蛇.1bd89087.jpg";